// extracted by mini-css-extract-plugin
export var image = "gC_dl";